let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c9qyC")).then(() => parcelRequire('byicS'));